import { AUTO, Game, Scale, type Types } from 'phaser';
import type { FieryRouteLevel } from '../domain/routeLevels';
import type { FieryRouteMode } from '../../../../shared/fieryRouteModes';
import { ROUTE_GAME } from './Constants';
import { AlevliRotaScene } from './AlevliRotaScene';

export function startAlevliRotaGame(
  parent: string,
  gameId: string,
  levels: FieryRouteLevel[],
  restartEnabled = true,
  mode: FieryRouteMode = 'challenge',
): Game {
  const config: Types.Core.GameConfig = {
    type: AUTO,
    width: ROUTE_GAME.WIDTH,
    height: ROUTE_GAME.HEIGHT,
    parent,
    backgroundColor: '#183f3a',
    physics: {
      default: 'arcade',
      arcade: { gravity: { x: 0, y: 0 }, debug: false },
    },
    // Tam ekranda araç çubuğunun ardından kalan alan 16:9 olmayabilir.
    // ENVELOP bu durumda yan boşluk bırakmaz; yalnız gerektiğinde üst/alt
    // kenardan küçük bir kısmı kırpar.
    scale: { mode: Scale.ENVELOP, autoCenter: Scale.CENTER_BOTH },
    scene: [new AlevliRotaScene(levels, gameId, restartEnabled, mode)],
  };
  return new Game(config);
}
